import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "acd88dc8-2fee-49b8-9bc0-693d02439825", content: "Around 1 l", options: {} },
  { id: "527848fe-b87f-4cec-b557-72cb0a8b22d7", content: "Around 2.5 l", options: {} },
  { id: "fc6d1c5f-14ee-4eeb-9375-ede56d94a3e8", content: "Around 5 l", options: {} },
  { id: "f74b40e7-454e-4a12-955d-94720fe41a4f", content: "Around 10 l", options: {} },
  { id: "1a966122-dbe4-4a56-932a-91ea9e24ee00", content: "Around 20 l", options: {} },
  { id: "aa8e158d-6af1-40af-8872-110be745f228", content: "Around 50 l", options: {} },
];

export const task: Task = {
  id: "1b9e14b4-bf6e-46f2-b241-a1e9911a38f9",
  solutionType: "select",
  type: "checkbox",
  options: {
    isMultiple: false,
    columns: 2,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["fc6d1c5f-14ee-4eeb-9375-ede56d94a3e8"],
};
